import { Accordion, AccordionProps } from '@mantine/core';
import React from 'react';

import { NavigationMenu } from './sections/NavigationMenu';
import { SignInPage } from './sections/SignInPage';
import { ContentWrapper, TabContainer } from '../common';

export function Design() {
  return (
    <TabContainer>
      <ContentWrapper>
        <Accordion
          multiple
          chevronPosition="right"
          defaultValue={['sign-in-page']}
          styles={accordionStyles}
        >
          <Accordion.Item value="sign-in-page">
            <Accordion.Control>Sign-In Page</Accordion.Control>
            <Accordion.Panel>
              <SignInPage />
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="navigation-menu">
            <Accordion.Control>Navigation Menu</Accordion.Control>
            <Accordion.Panel>
              <NavigationMenu />
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </ContentWrapper>
    </TabContainer>
  );
}

const accordionStyles: AccordionProps['styles'] = (theme) => ({
  item: {
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  control: {
    paddingInline: 0,

    ...theme.fn.hover({
      background: theme.white,
    }),
  },
  label: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 500,
    color: theme.colors.blue_gray[9],
  },
  content: {
    padding: 0,
    paddingBottom: theme.spacing.xl,
  },
});
